import React, { Fragment } from "react";
import { ArticleCard } from "../components/Articles/ArticleCard";
import { PageHero } from "../components/Global/PageHero";
import { BackToTop } from "../templates/BackToTop";

export const Articles = () => (
  <Fragment>
    <PageHero
      eyebrow="The Word"
      title="Latest"
      highlight="Articles"
      subtitle="Understand the way of God and digest the word daily."
    />
    <ArticleCard />
    <BackToTop />
  </Fragment>
);
